import React from "react";
import "./VideoCard.css"; // Add this CSS file for styling
import { TextField } from "@mui/material";

const VideoCard = ({ index, setRenderedVideos, likes, views, videoSrc, errorMsg }) => { // Destructure errorMsg prop

    const updateVideoKey = (index, key, value) => {
        setRenderedVideos((prevVideos) => {
            // Make a shallow copy of the array
            const updatedVideos = [...prevVideos];
            // Make a shallow copy of the object at the given index
            const updatedVideo = { ...updatedVideos[index] };
            // Update the specific key
            updatedVideo[key] = value;
            // Replace the old object with the updated one
            updatedVideos[index] = updatedVideo;
            return updatedVideos;
        });
    };

    return (
        <div className="video-card">
            <div className="video-preview">
                <video src={videoSrc} controls></video>
            </div>
            <div className="video-info">
                <div className="info-section">
                    <span>Like</span>
                    <TextField
                        style={{ maxWidth: '80px' }}
                        hiddenLabel
                        value={likes}
                        onChange={(e) => updateVideoKey(index, 'likes', e.target.value)}
                        id="filled-hidden-label-small"
                        variant="filled"
                        size="small"
                    />
                </div>
                {/* Failure message shown here if present */}
                {typeof errorMsg === 'string' && errorMsg && (
                    <div style={{ color: 'red', fontSize: '13px', margin: '4px 0', wordBreak: 'break-word' }}>
                        {errorMsg}
                    </div>
                )}
                <div className="info-section">
                    <span>Views</span>
                    <TextField
                        style={{ maxWidth: '80px' }}
                        hiddenLabel
                        value={views}
                        onChange={(e) => updateVideoKey(index, 'views', e.target.value)}
                        id="filled-hidden-label-small"
                        variant="filled"
                        size="small"
                    />
                </div>
            </div>
        </div>
    );
};

export default VideoCard;